import { LitElement, html } from 'lit';

class NavContainer extends LitElement {
  static get properties() {
    return {
      toggleClass: { type: String },
    };
  }

  constructor() {
    super();
    this.toggleClass = 'fullscreen';
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.applySavedToggleState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(event) {
    if (event.metaKey && event.key === '.') {
      const body = document.body;
      body.classList.toggle(this.toggleClass);
      localStorage.setItem('navContainerClass', body.classList.contains(this.toggleClass));
    }
  }

  applySavedToggleState() {
    const body = document.body;
    const savedClassValue = localStorage.getItem('navContainerClass');
    if (savedClassValue === 'true') {
      body.classList.add(this.toggleClass);
    } else if (savedClassValue === 'false') {
      body.classList.remove(this.toggleClass);
    }
  }

  render() {
    return html`<slot></slot>`;
  }
}

customElements.define('nav-container', NavContainer);